const install = (Vue, vm) => {
	
	uni.$u.http.setConfig((config) => {
	    config.baseURL = vm.$baseUrl;
		config.timeout = 60000;
	    return config;
	})
	
	let loginByWxMini = (data = {}) => vm.$u.http.post('system/loginByWxMini', data);	// 微信小程序登录
	let getUserInfo = (params = {}) => vm.$u.http.get('system/getUserInfo', { params });	// 获取当前登录的用户信息
	let logout = (data = {}) => vm.$u.http.post('system/logout', data);	// 退出登录
	let solutionsList = (data = {}) => vm.$u.http.post('business/solutions/list', data);	// 保险方案列表查询
	let getCountCyclePriceVO = (data = {}) => vm.$u.http.post('business/insuranceApply/getCountCyclePriceVO', data);	// 获取保单止期与初始金额
	let solutionsById = (id) => vm.$u.http.get(`business/solutions/${id}`);	// 根据ID查询保险方案
	let findListByDTO = (data = {}) => vm.$u.http.post('business/dispatchUnit/findListByDTO', data);	// 派遣单位数据列表
	let worktypeFindListByDTO = (data = {}) => vm.$u.http.post('business/worktype/findListByDTO', data);	// 根据条件工种列表
	let insuranceApplyCreate = (data = {}) => vm.$u.http.post('business/insuranceApply/create', data);	// 新建投保
	let insuranceApplyPage = (data = {}) => vm.$u.http.post('business/insuranceApply/page', data);	// 投保申请分页查询
	let insuranceApplyById = (id) => vm.$u.http.get(`business/insuranceApply/${id}`);	// 获取投保详情
	let applyDetailPage = (data = {}) => vm.$u.http.post('business/applyDetail/page', data);	// 在保人员列表
	let applyChangePage = (data = {}) => vm.$u.http.post('business/applyChange/page', data);	// 加减保换厂列表
	let applyChangeById = (id) => vm.$u.http.get(`business/applyChange/${id}`);	// 获取加减保换厂详情
	let applyChagneDetailPage = (data = {}) => vm.$u.http.post('business/applyChagneDetail/page', data);	// 加减保换厂分页查询
	let insuranceApplyFindListByDTO = (data = {}) => vm.$u.http.post('business/insuranceApply/findListByDTO', data);	// 投保申请列表
	let getChangeCountCyclePriceVO = (data = {}) => vm.$u.http.post('business/applyChange/getChangeCountCyclePriceVO', data);	// 加减保业务补充金额
	let applyChangeCreate = (data = {}) => vm.$u.http.post('business/applyChange/create', data);	// 加减保换厂申请
	let memberPage = (data = {}) => vm.$u.http.post('business/member/page', data);	// 员工分页查询
	let memberById = (id) => vm.$u.http.get(`business/member/${id}`);	// 获取员工详情
	let memberInsuranceFindList = (data = {}) => vm.$u.http.post('business/memberInsurance/findList', data);	// 员工投保明细
	let memberFindListByDTO = (data = {}) => vm.$u.http.post('business/member/findListByDTO', data);	// 员工列表
	let settleClaimsPage = (data = {}) => vm.$u.http.post('business/settleClaims/page', data);	// 报案列表
	let settleClaimsById = (id) => vm.$u.http.get(`business/settleClaims/${id}`);	// 报案理赔详情
	let findTreeList = (data = {}) => vm.$u.http.post('business/areas/findTreeList', data);	// 区域树列表
	let settleClaimsCreate = (data = {}) => vm.$u.http.post('business/settleClaims/create', data);	// 新建报案
	let settleClaimsUpdateById = (data = {}) => vm.$u.http.post('business/settleClaims/updateById', data);	// 编辑报案
	let guaranteeNum = () => vm.$u.http.get('business/insuranceApply/guaranteeNum');	// 获取保障中人数
	let applyOpt = (data = {}) => vm.$u.http.post('business/insuranceApply/applyOpt', data);	// 申请记录状态处理
	let sendSms = (data = {}) => vm.$u.http.post('business/smsEmail/sendSms', data);	// 发送短信验证码
	let validateCode = (params = {}) => vm.$u.http.get('business/smsEmail/validateCode', {params});	// 短信验证 - 企业验签
	let getSignLink = (id) => vm.$u.http.get(`business/insuranceApply/getSignLink/${id}`);	// 企业签署保单
	let signTBQRSLink = (data = {}) => vm.$u.http.post('business/insuranceApply/signTBQRSLink', data);	// 方案确认书签章业务
	let applyChangeOpt = (data = {}) => vm.$u.http.post('business/applyChange/applyChangeOpt', data);	// 加减宝换厂业务处理
	let getJiajianBaoSignLink = (data = {}) => vm.$u.http.post('business/applyChange/getJiajianBaoSignLink', data);	// 获取加减保签章地址
	let getMemberListOnlineSignLink = (data = {}) => vm.$u.http.post('business/insuranceApply/getMemberListOnlineSignLink', data);	// 人员名单签章
	let getSignWTBTBDLink = (data = {}) => vm.$u.http.post('business/insuranceApply/getSignWTBTBDLink', data);	// 投保申请单签章业务
	let getChangeMemberListOnlineSignLink = (data = {}) => vm.$u.http.post('business/applyChange/getChangeMemberListOnlineSignLink', data);	// 投保确认书签章业务
	let supplement = (data = {}) => vm.$u.http.post('business/settleClaims/supplement', data);	// 补充说明
	let claimsUploadFile = (data = {}) => vm.$u.http.post('business/settleClaims/claimsUploadFile', data);	// 附件上传
	let getAgreement = (data = {}) => vm.$u.http.post('/system/dict/getAgreement', data);	// 附件上传
	let delFile = (id, fileId) => vm.$u.http.get(`business/settleClaims/delFile/${id}/${fileId}`);	// 删除附件
	
	let findList = (data = {}) => vm.$u.http.post('business/applyDetail/findList', data);	// 方案查询
	let saveSettleClaims = (data = {}) => vm.$u.http.post('business/settleRisk/saveSettleClaims', data);	// 理赔报案
	let saveSupplementFile = (data = {}) => vm.$u.http.post('business/settleRisk/saveSupplementFile', data);	// 添加材料
	let confirmFee = (id) => vm.$u.http.get(`business/settleRisk/confirmFee?id=${id}`);	// 确认金额
	let insuranceFile = (id, type) => vm.$u.http.get(`business/insurance/${id}?type=${type}`);	// 根据ID查询
	
	
	vm.$u.api = {
		loginByWxMini,
		getAgreement,
		getUserInfo,
		logout,
		solutionsList,
		getCountCyclePriceVO,
		solutionsById,
		findListByDTO,
		worktypeFindListByDTO,
		insuranceApplyCreate,
		insuranceApplyPage,
		insuranceApplyById,
		applyDetailPage,
		applyChangePage,
		applyChangeById,
		applyChagneDetailPage,
		insuranceApplyFindListByDTO,
		getChangeCountCyclePriceVO,
		applyChangeCreate,
		memberPage,
		memberById,
		memberInsuranceFindList,
		memberFindListByDTO,
		settleClaimsPage,
		settleClaimsById,
		findTreeList,
		settleClaimsCreate,
		settleClaimsUpdateById,
		guaranteeNum,
		applyOpt,
		sendSms,
		validateCode,
		getSignLink,
		signTBQRSLink,
		applyChangeOpt,
		getJiajianBaoSignLink,
		getMemberListOnlineSignLink,
		getSignWTBTBDLink,
		getChangeMemberListOnlineSignLink,
		supplement,
		claimsUploadFile,
		delFile,
		findList,
		saveSettleClaims,
		saveSupplementFile,
		confirmFee,
		insuranceFile
	};
}

export default { install }